import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function UserIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M4 26.69A7.691 7.691 0 0 1 11.691 19h8.618A7.691 7.691 0 0 1 28 26.69c0 1.753-1.186 3.274-2.915 3.56A56.18 56.18 0 0 1 16 31a56.18 56.18 0 0 1-9.085-.75C5.186 29.965 4 28.444 4 26.69ZM8.5 8.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z"
      />
    </BaseIcon>
  );
}
